import { app_search_children } from "dependencies/search/index.js"
// import icon from "../../../../assets/images/leftMenu/basePortal/icon_search.png"
let icon = "icon-portal-menu_search"
export default {
  name: "搜索",
  id: "",
  thumbnail: icon,
  type: "cxSystemSearch",
  componentType:"emptyLayoutComponent",
  // typeId: "1990b76a6a85e111ed0b1e4831eb1a817cdc",
  typeId: "",
  // children: []
  children: app_search_children
}
